<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getLevel" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.gradeId" placeholder="级别" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.gradeName" :value="item.gradeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList(),gradeList=[]" type="default">重置</el-button>
        <!--        <el-button @click="exam()" type="primary">导入名单</el-button>-->
        <!--        <el-button @click="exportExcel()" type="primary">导出成绩单</el-button>-->
        <el-button @click="exportResultExcel()" type="primary">导出成绩表格</el-button>
        <el-button @click="getExportExamLicense()" type="primary" style="margin-right: 10px;">导出准考证（线下评分）</el-button>
      </div>
      <!--      <div class="text-right" style="margin-top: 10px;">-->
      <!--        <el-button @click="publish()" type="primary" style="margin-right: 0px;">-->
      <!--          发布-->
      <!--        </el-button>-->
      <!--      </div>-->
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <!--        <el-table-column type="selection" width="55" :selectable="row=>row.evaluateStatus>=2"></el-table-column>-->
        <el-table-column prop="examineeName" label="姓名">
          <!--          <div slot-scope="scope" class="text-click pointer"-->
          <!--               @click="$router.push({path:'./performance-edit',query:{batchId:scope.row.batchId,specialtyId:scope.row.specialtyId,examId:scope.row.examId}})">-->
          <!--            {{scope.row.examineeName}}-->
          <!--          </div>-->
        </el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号"></el-table-column>
        <el-table-column prop="evaluateResult" label="综合成绩"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="导入考生数据" v-if="examForm.show" :visible.sync="examForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Exam :row="examForm.row" @close="onClose"></Exam>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
      <div v-if="currentNum && totalNum" style="width: 100%;text-align: center;margin-top: 10px;">
        当前数据进度：
        <span>{{currentNum}}</span>/<span>{{totalNum}}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import Exam from './performance-edit'

export default {
  name: 'vocal',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      agentList: [],
      evaluateStatus: [],
      examForm: { show: false, row: null },
      dialogVisible: false,
      percent: null,
      gradeList: [],
      totalNum: '',
      currentNum: ''
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async getLevel (event) {
      if (event) {
        this.queryParam.gradeId = ''
      }
      this.gradeList = await this.$HTTP.ApiSpecialty.getGradeList({ specialtyId: this.queryParam.specialtyId, status: 2 })
      await this.getPage()
    },
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      // this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
        this.queryParam.gradeId = ''
        this.gradeList = []
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.dialogVisible = false
        this.editForm.show = false
        this.editForm.row = null
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        if (queryParam && !queryParam.pageSize) {
          this.$set(queryParam, 'pageSize', this.page.pageSize)
        }
        newQueryParam.evaluateStatus = [2, 3]
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.ApiCommon.getAchievementPage(newQueryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async publish () {
      if (!this.multipleSelection.length) {
        throw new Error('请选择要操作的记录')
      }
      let confirm = await this.$confirm('确定要发布该记录吗？', '提示', { type: 'warning' })
      if (confirm === 'confirm') {
        await this.$HTTP.GradeExam.publish({
          evaluateExamIds: this.Tool.joinList(this.multipleSelection, 'evaluateExamId')
        })
        this.$message({ type: 'success', message: '发布成功' })
        await this.getPage()
      }
    },
    async onClose (event) {
      try {
        // await this.$HTTP.GradeExam.getImportExamResult(this.queryParam)
        this.getTaskInfo('import_exam_result')
        this.examForm.show = false
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async exportExcel (queryParam) {
      try {
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        await this.$HTTP.ApiCommon.getExportExamResult(newQueryParam)
        this.getTaskInfo('export_exam_result')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async exportResultExcel (queryParam) {
      try {
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        await this.$HTTP.ApiCommon.getexportEvaluateExamResult(newQueryParam)
        this.getTaskInfo('export_evaluate_exam_result')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getExportExamLicense (queryParam) {
      try {
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        await this.$HTTP.ApiCommon.getExportExamLicense(newQueryParam)
        this.getTaskInfo('export_exam_license')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamImport.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          this.totalNum = taskInfo.totalNum
          this.currentNum = taskInfo.currentNum
          if (taskInfo) {
            if (taskInfo.status == 0 && taskInfo.status != 2) {
              this.dialogVisible = true
            }
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              this.dialogVisible = false
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
            this.$message({ type: 'error', message: taskInfo.errMsg })
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    async exam (row) {
      this.examForm.show = true
      if (row) {
        this.examForm.row = row
      } else {
        this.examForm.row = null
      }
    }
  }
}
</script>
